import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Radio } from "lucide-react";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { ItineraryTab } from "./tabs/ItineraryTab";
import { PracticalInfoTab } from "./tabs/PracticalInfoTab";
import { RoadmapTab } from "./roadmap/RoadmapTab";
import { TripChatbot } from "./TripChatbot";
import { PaymentWall } from "./PaymentWall";
import { PendingValidation } from "./TripStates";

const LORA = { fontFamily: "'Lora', Georgia, serif" };
const TRIAL_TABS = [
  { value: "itineraire", label: "Itinéraire" },
  { value: "roadmap", label: "Feuille de Route" },
  { value: "infos", label: "Infos pratiques" },
];

export function TrialView({ trip, tripId }) {
  const [showUnlock, setShowUnlock] = useState(false);
  const unlockRef = useRef(null);
  const onUnlock = () => {
    setShowUnlock(true);
    setTimeout(() => unlockRef.current?.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
  };

  return (
    <>
      <div className="flex items-start gap-3 bg-[#FDF8F3] border-l-4 border-[#C17F59] p-4 mb-6 rounded-sm" data-testid="trial-banner">
        <Sparkles size={16} strokeWidth={1.5} className="text-[#C17F59] mt-0.5 flex-shrink-0" />
        <p className="text-sm text-[#5C554E]" style={LORA}>
          Aperçu gratuit — généré automatiquement. Je relis et valide l'itinéraire complet après votre commande.
        </p>
      </div>

      <div className="flex flex-wrap gap-3 mb-6">
        <button onClick={onUnlock} className="btn-primary text-sm" data-testid="trial-unlock-top-btn">Débloquer tout mon voyage</button>
        <Link to={`/trip/${tripId}/live`} className="btn-secondary text-sm inline-flex items-center gap-2" data-testid="trial-live-preview-link">
          <Radio size={14} strokeWidth={1.5} /> Aperçu du Mode Sur Place
        </Link>
      </div>

      <Tabs defaultValue="itineraire" className="w-full" data-testid="trial-tabs">
        <TabsList className="bg-[#F1EBE1] border border-[#DCD4C6] p-1 flex flex-wrap gap-1 h-auto rounded-sm mb-4">
          {TRIAL_TABS.map(({ value, label }) => (
            <TabsTrigger key={value} value={value} className="text-sm rounded-sm data-[state=active]:bg-[#C17F59] data-[state=active]:text-[#F9F6F0]" style={LORA} data-testid={`tab-${value}`}>
              {label}
            </TabsTrigger>
          ))}
        </TabsList>
        <TabsContent value="itineraire"><ItineraryTab result={trip.result || {}} trip={trip} onUnlock={onUnlock} /></TabsContent>
        <TabsContent value="roadmap"><RoadmapTab tripId={tripId} trip={trip} onUnlock={onUnlock} /></TabsContent>
        <TabsContent value="infos"><PracticalInfoTab result={trip.result || {}} destination={trip.destination} tripId={tripId} planType={trip.plan_type} isAdmin={false} /></TabsContent>
      </Tabs>

      <div ref={unlockRef} data-testid="trial-unlock-section">
        {showUnlock && (trip.admin_validated ? <PaymentWall trip={trip} /> : <PendingValidation trip={trip} />)}
      </div>

      <TripChatbot tripId={tripId} trialRemaining={trip.trial_chat_remaining} />
    </>
  );
}
